import axios from "axios";

export default axios.defaults.baseURL = "https://api.indiatour.ind.in/";
// export default axios.defaults.baseURL = "http://localhost:8080/";
